<template>
  <div class="skeletonShimmer">

    <template v-if="hasProvidedSlot && this.getTemplateName">
      <component :is="getTemplateName">
        <slot />
      </component>
    </template>

    <template v-else-if="hasProvidedSlot">
      <slot name="customTemplate" />
    </template>

    <template v-else-if="this.getTemplateName">
      <component :is="getTemplateName">
        <slot />
      </component>
    </template>

    <template v-else>
       <SkeletonDefault>
         <slot />
      </SkeletonDefault>
    </template>
  </div>
</template>

<script>
import SkeletonDefault from '@/components/skeletonShimmer/skeletonTemplates/SkeletonDefault.vue';
import SkeletonSelectPhoneNumber from '@/components/skeletonShimmer/skeletonTemplates/SkeletonSelectPhoneNumber.vue';

// TODO: [Improvement]create an internal loader control
// for "passing view content as slot scenario"

export default {
  name: 'VSkeletonShimmer',
  components: {
    SkeletonDefault,
    SkeletonSelectPhoneNumber,
  },

  props: {
    templateName: String
  },

  computed: {
    hasProvidedSlot() {
      return !!this.$slots.customTemplate;
    },

    getTemplateName() {
      let template = null;

      if (this.templateName) {
        const templateFirstCharacter = `${this.templateName.charAt(0).toUpperCase()}`;
        const templateEndString = `${this.templateName.slice(1, this.templateName.length)}`;

        template = `Skeleton${templateFirstCharacter}${templateEndString}`;
      }

      return template;
    }
  },
};
</script>

<style lang="scss">
.skeletonShimmer {
  $self: &;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  &__circle {
    border-radius: 50%;
    height: 88px;
    margin: 0 auto 24px;
    width: 88px;
  }

  &__paragraph {
    border-radius: 4px;
    height: 16px;
    margin-bottom: 8px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__template {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
  }

  &__span {
    border-radius: 4px;
    height: 16px;
    margin: 24px auto 8px;
    text-align: center;
    width: 75%;
  }

  & &__radioList {
    animation: initial;
    background: initial;
    display: flex;
    flex-direction: column;
    margin-top: 36px;
    padding: 16px 16px;
    width: 100%;
  }

  & &__radio {
    animation: initial;
    background: initial;
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    padding: 8px 0;
  }

  &__input {
    border-radius: 50%;
    height: 24px;
    margin-right: 16px;
    width: 24px;
  }

  &__label {
    border-radius: 4px;
    height: 24px;
    text-align: center;
    width: calc(100% - 32px);
  }

  &__button {
    border-radius: 4px;
    height: 48px;
    margin: 8px auto 24px;
    max-width: 320px;
    width: 100%;
  }

  &__buttons {

    > div:first-child {
      margin-bottom: 12px;
    }
  }
}

.pulse * {
  animation: pulse 1s infinite ease-in-out;
}

.wave * {
  animation: wave 1s infinite linear forwards;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%) 800px 104px;
}

@keyframes pulse {
  0% {
    background-color: rgba(165, 165, 165, 0.1);
  }
  50% {
    background-color: rgba(165, 165, 165, 0.3);
  }
  100% {
    background-color: rgba(165, 165, 165, 0.1);
  }
}

@keyframes wave {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}
</style>
